import pluralize from 'pluralize';
import { MediaSet } from 'ca-api-client';
export default class AddItemsToExistingSet {
    config() {
        return {
            title: 'Add items to existing collection',
            description: 'Choose an existing collection to add items to.',
            mode: 'single',
            tree: true,
            sets: true,
            media: false,
            upload: {
                allow: false,
                allowMultiple: true,
            },
            defaultFilters: [],
            filterOptions: [],
        };
    }
    async doAction() {
        console.log('UploadNewVersion::doAction()');
        const items = App.$store.getters.getGalleryMediaItemSelectedIds;
        const itemTypes = App.$store.getters.getGallerySelectedByType;
        const selected = App.$store.getters.getMediaSelectSelected[0];

        const set = await MediaSet.params({ include: 'children' }).$find(selected.id);

        const hasItems = set.media.data.filter((item) => items.includes(item.id)).map((item) => item.id);
        const uniqueItems = items.filter((item) => !hasItems.includes(item));

        if (hasItems.length > 0) {
            const html = document.createElement('div');
            const p = document.createElement('p');

            const found = document.createElement('strong');
            found.classList.add('text-danger');
            found.appendChild(document.createTextNode(`${pluralize('item', hasItems.length, true)}`));
            const foundText = document.createTextNode(' were already present and will not be added again.');

            if (uniqueItems.length > 0) {
                const notFound = document.createElement('strong');
                notFound.classList.add('text-success');
                notFound.appendChild(document.createTextNode(`${pluralize('item', uniqueItems.length, true)}`));
                const notFoundText = document.createTextNode(' will be added to the collection.');

                p.appendChild(notFound);
                p.appendChild(notFoundText);
                p.appendChild(document.createElement('br'));
            }

            p.appendChild(found);
            p.appendChild(foundText);
            html.appendChild(p);

            return ca.confirm(
                {
                    params: [uniqueItems],
                    type: 'warning',
                    title: 'The selected collection already contains items',
                    html: html.outerHTML,
                    width: '500px',
                    showConfirmButton: uniqueItems.length > 0,
                },
                (items) => {
                    return new Promise((resolve) => {
                        App.$store
                            .dispatch('updateSet', {
                                id: set.id,
                                data: {
                                    media: itemTypes.media,
                                    children: itemTypes.sets,
                                },
                            })
                            .then((response) => {
                                resolve(response);
                            });
                    });
                }
            );
        } else {
            return new Promise((resolve) => {
                App.$store
                    .dispatch('updateSet', {
                        id: set.id,
                        data: {
                            media: itemTypes.media,
                            children: itemTypes.sets,
                        },
                    })
                    .then((response) => {
                        resolve(response);
                    });
            });
        }
    }
}
